import {
  SET_WHITE_INK_OPTIONS_NEEDED,
  SET_WHITE_INK_OPTIONS_NEXT_DISABLED,
  SET_INCLUDES_WHITE_UNDERPRINT,
  STATE_ARTWORK_PREVIEW,
  SET_ARTWORK_PREVIEW_ZOOM,
  SET_LAST_CLICK_COORDINATES,
  SET_WHITE_INK_OPTION,
  SET_TOLERANCE,
  SET_ADVANCED_MODE_VISIBLE,
  SET_ADVANCED_MODE_TOLERANCE_SLIDER_ENABLED,
  SET_TOUCH_UP_MODE,
  SET_DARK_MODE,
  RESET_WHITE_INK_OPTIONS_DATA,
} from '@app/actions/_types';

const initialWhiteInkOptionsState = {
  whiteInkOptionsNeeded: null,
  nextDisabled: true,
  includesWhiteUnderprint: false,
  whiteInkOption: null,
  artworkPreview: null,
  isDarkMode: false,
  artworkPreviewZoom: 1,
  tolerance: null,
  lastClickCoordinates: null,
  advancedMode: {
    isVisible: false,
    touchUpMode: null,
    toleranceSliderEnabled: false,
  },
};

export default (state = initialWhiteInkOptionsState, { type, payload }) => {
  switch (type) {
    case SET_WHITE_INK_OPTIONS_NEEDED:
      return { ...state, whiteInkOptionsNeeded: payload };
    case SET_WHITE_INK_OPTIONS_NEXT_DISABLED:
      return { ...state, nextDisabled: payload };
    case SET_INCLUDES_WHITE_UNDERPRINT:
      return { ...state, includesWhiteUnderprint: payload };
    case SET_WHITE_INK_OPTION:
      return { ...state, whiteInkOption: payload };
    case SET_TOLERANCE:
      return { ...state, tolerance: payload };
    case STATE_ARTWORK_PREVIEW:
      return { ...state, artworkPreview: payload };
    case SET_ARTWORK_PREVIEW_ZOOM:
      return { ...state, artworkPreviewZoom: payload };
    case SET_LAST_CLICK_COORDINATES:
      return { ...state, lastClickCoordinates: payload };
    case SET_ADVANCED_MODE_VISIBLE:
      return { ...state, advancedMode: { ...state.advancedMode, isVisible: payload } };
    case SET_ADVANCED_MODE_TOLERANCE_SLIDER_ENABLED:
      return { ...state, advancedMode: { ...state.advancedMode, toleranceSliderEnabled: payload } };
    case SET_TOUCH_UP_MODE:
      return { ...state, advancedMode: { ...state.advancedMode, touchUpMode: payload } };
    case SET_DARK_MODE:
      return { ...state, isDarkMode: payload };
    case RESET_WHITE_INK_OPTIONS_DATA:
      return { ...initialWhiteInkOptionsState };
    default:
      return state;
  }
};
